
import { useMutation, useQuery } from "react-query";
import leadLoginService from "../services/leadLoginServices";

const useLeadLogin = (onData) => {
    return useMutation(leadLoginService.leadLogin, {
        onSuccess: (data) => {
            onData(data);
        },
    });
};

const useForgotpassword = (onData) => {
    return useMutation(leadLoginService.forgotpassword, {
        onSuccess: (data) => {
            onData(data);
        },
    });
};

// const useChangePassword = (onSuccess, onError) => {
//     return useMutation(leadLoginService.changePassword, {
//         onSuccess,
//         onError
//     });
// };
const useChangePassword = (onSuccess, onError) => {
    return useMutation(leadLoginService.changePassword, {
        onSuccess: (data, variables, context) => {
            // Check if the response indicates an error
            if (data?.status >= 400) {
                onError(data);
            } else {
                onSuccess(data, variables, context);
            }
        },
        onError,
    });
};

// Data fetching queries
export const useSessions = (options = {}) => {
    return useQuery({
        queryKey: ['sessions'],
        queryFn: leadLoginService.getSessions,
        staleTime: 5 * 60 * 1000,
        onError: (error) => console.error("Error fetching sessions:", error),
        ...options
    });
};

export const useSpeakers = (options = {}) => {
    return useQuery({
        queryKey: ['speakers'],
        queryFn: leadLoginService.getSpeakers,
        staleTime: 5 * 60 * 1000,
        onError: (error) => console.error("Error fetching speakers:", error),
        ...options
    });
};

export const useVenues = (options = {}) => {
    return useQuery({
        queryKey: ['venues'],
        queryFn: leadLoginService.getVenues,
        staleTime: 5 * 60 * 1000,
        onError: (error) => console.error("Error fetching venues:", error),
        ...options
    });
};

export const useSessionSponsors = (options = {}) => {
    return useQuery({
        queryKey: ['sessionSponsors'],
        queryFn: leadLoginService.getSessionSponsors,
        staleTime: 5 * 60 * 1000,
        onError: (error) => console.error("Error fetching session sponsors:", error),
        ...options
    });
};

export const useSponsors = (options = {}) => {
    return useQuery({
        queryKey: ['sponsors'],
        queryFn: leadLoginService.getSponsors,
        staleTime: 5 * 60 * 1000,
        onError: (error) => console.error("Error fetching sponsors:", error),
        ...options
    });
};
const leadLoginQueries = {
    useLeadLogin,
    useForgotpassword,
    useChangePassword,
    
    // Data fetching
    useSessions,
    useSpeakers,
    useVenues,
    useSessionSponsors,
    useSponsors
};

export default leadLoginQueries
